import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { AlertRuleApi } from '../../../apis/AlertRuleApi/AlertRuleApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { IAlertRuleConfiguration, IUpdateAlertRuleConfigurationRequest } from '../Alert';

export function useUpdateAlertRuleConfiguration() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<IAlertRuleConfiguration, AppMedError, { configId: number; request: IUpdateAlertRuleConfigurationRequest }>({
        mutationKey: [QueryKeys.alertRuleConfigurations, 'update'],
        mutationFn: async ({ configId, request }) => {
            return await AlertRuleApi.updateAlertRuleConfiguration(configId, request);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.alertRuleConfigurations] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.journalAlertConfigurations] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.questionnaireAlertConfigurations] });
            notifications.show({
                title: t('notification.success'),
                message: t('alertRule.notifications.configurationUpdated'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('notification.error'),
                message: error?.message || t('notification.error'),
                color: 'red',
            });
        },
    });
}
